import angular from 'angular'
import contentComment from './contentComment.component'
import contentCommentDirective from './contentComment.directive'
import commentMenuPopover from './commentMenuPopover.directive'

export default angular
  .module('ellipsis.contentComment', [])
  .component('contentComment', contentComment)
  .directive('contentCommentDirective', contentCommentDirective)
  .directive('commentMenuPopover', commentMenuPopover)
